import { toPercent } from "@videojs/utils/number";
//#region src/core/ui/slider/segments.ts
/**
* Localizes ordered numeric ranges into slider geometry and interaction state.
*
* @internal
*/
var SliderSegmentsCore = class {
	getGeometry(input) {
		const { ranges, min, max, orientation } = input;
		const domain = max - min;
		if (!Number.isFinite(domain) || domain <= 0) return [];
		const valid = ranges.filter((segment) => {
			const size = (segment.end - segment.start) / domain;
			const offset = (segment.start - min) / domain;
			return Number.isFinite(size) && Number.isFinite(offset) && size > 0;
		});
		return valid.map((segment, index) => {
			const offset = (segment.start - min) / domain;
			const size = (segment.end - segment.start) / domain;
			const segmentSize = `${size * 100}%`;
			return {
				...segment,
				index,
				last: index === valid.length - 1,
				orientation,
				width: orientation === "horizontal" ? segmentSize : void 0,
				height: orientation === "vertical" ? segmentSize : void 0,
				startPercent: `${offset * 100}%`,
				endPercent: `${(offset + size) * 100}%`
			};
		});
	}
	getState(segment, slider, pointerValue) {
		const { last, ...geometry } = segment;
		const contains = (value) => value >= segment.start && (value < segment.end || last && value === segment.end);
		const active = contains(slider.value);
		const pointing = slider.pointing && contains(pointerValue);
		const dragging = slider.dragging && contains(pointerValue);
		const focused = slider.interactive && !slider.pointing && !slider.dragging;
		return {
			...geometry,
			fillPercent: toPercent(slider.value, segment.start, segment.end),
			active,
			pointing,
			dragging,
			highlighted: segment.highlight !== false && pointing,
			interactive: pointing || dragging || focused && active
		};
	}
};
//#endregion
export { SliderSegmentsCore };

//# sourceMappingURL=segments.js.map